(() => {
  "use strict";
  const ROOT = window.Shopify?.routes?.root || "/";
  const raw = (document.documentElement.lang || window.Shopify?.locale || "en").toLowerCase();
  const language = raw === "es" || raw.startsWith("es-") ? "es"
    : raw === "pt" || raw.startsWith("pt-") ? "pt-BR" : "en";
  const translations = {
    en: { prefix: "I agree to the ", label: "Alcoholic beverages shipping policy", alert: "Please accept the alcoholic beverages shipping policy to continue." },
    es: { prefix: "Acepto la ", label: "política de envío de bebidas alcohólicas", alert: "Acepta la política de envío de bebidas alcohólicas para continuar." },
    "pt-BR": { prefix: "Concordo com a ", label: "política de envio de bebidas alcoólicas", alert: "Aceite a política de envio de bebidas alcoólicas para continuar." }
  };
  const expectedUrl = new URL(`${ROOT}pages/rule-for-shipping-of-alcoholic-beverages`, location.origin).href;

  function adapt(container) {
    if (!container) return false;
    const nodes = Array.from(container.querySelectorAll('[id="tncText"]'));
    let matched = false;
    const text = translations[language];
    for (const box of nodes) {
      const link = box.querySelector('a[data-anchorlinkid="1"]');
      if (!link) continue;
      let current;
      try { current = new URL(link.href); } catch { continue; }
      if (!current.pathname.endsWith("/pages/rule-for-shipping-of-alcoholic-beverages")) continue;
      if (link.textContent !== text.label) link.textContent = text.label;
      if (link.href !== expectedUrl) link.href = expectedUrl;
      if (link.rel !== "noopener noreferrer") link.rel = "noopener noreferrer";
      if (box.textContent !== text.prefix + text.label) {
        // Preserve the existing anchor and checkbox. Only replace label text nodes.
        box.replaceChildren(document.createTextNode(text.prefix), link);
      }
      matched = true;
    }
    // Restrict the app alert translation to its known T&C containers.
    container.querySelectorAll('.gm_tncContainer .sweetAlertText').forEach(element => {
      if (element.textContent !== text.alert) element.textContent = text.alert;
    });
    return matched;
  }

  window.AlcoholConsentPolicyUI = Object.freeze({
    ensure(container, expectedLanguage) {
      if (expectedLanguage !== language) return false;
      if (!adapt(container)) return false;
      const boxes = Array.from(container.querySelectorAll('[id="tncText"]'));
      return boxes.some(box => {
        const link = box.querySelector('a[data-anchorlinkid="1"]');
        return link?.href === expectedUrl &&
          box.textContent === translations[language].prefix + translations[language].label;
      });
    }
  });

  let scheduled = false;
  function refresh() {
    scheduled = false;
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach(adapt);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {
    subtree: true, childList: true, characterData: true,
    attributes: true, attributeFilter: ["href", "lang"]
  });
  schedule();
})();

(() => {
  "use strict";

  const API_URL = "https://brazilian-consent-api.brazilianshop.workers.dev/consent";
  const ROOT = window.Shopify?.routes?.root || "/";
  const TERMS_VERSION = "1.2";
  const rawLocale = (document.documentElement.lang || window.Shopify?.locale || "en").toLowerCase();
  const LANGUAGE = rawLocale === "es" || rawLocale.startsWith("es-") ? "es"
    : rawLocale === "pt" || rawLocale.startsWith("pt-") ? "pt-BR" : "en";
  const POLICY_HASHES = {
    en: "01f4b67d20f3599faa460f71c0f6856ce457ab0ed01d9488d876599659feb19e",
    es: "b9ae3b333ff2e0f929159293977429d7dbf763b34b725ca08a759569e6c3b12f",
    "pt-BR": "e666cd03ae92f9eb252ada4265a7482ceecd18eb82be767834cb31c7d667f99a"
  };
  const MESSAGES = {
    "Please accept the alcoholic beverages shipping policy.": {
      es: "Acepta la política de envío de bebidas alcohólicas.",
      "pt-BR": "Aceite a política de envio de bebidas alcoólicas."
    },
    "Please enter your full name.": {
      es: "Introduce tu nombre completo.", "pt-BR": "Preencha seu nome completo."
    },
    "Please enter a valid email address.": {
      es: "Introduce una dirección de correo electrónico válida.",
      "pt-BR": "Preencha um endereço de e-mail válido."
    },
    "Please complete the security verification if prompted.": {
      es: "Completa la verificación de seguridad si se solicita.",
      "pt-BR": "Conclua a verificação de segurança, se solicitada."
    },
    "Recording your acceptance. Please wait.": {
      es: "Registrando tu aceptación. Espera un momento.",
      "pt-BR": "Registrando seu aceite. Aguarde."
    },
    "Acceptance recorded. Continuing to checkout.": {
      es: "Aceptación registrada. Continuando al pago.",
      "pt-BR": "Aceite registrado. Continuando para o checkout."
    },
    "Could not reset acceptance. Please reload before continuing.": {
      es: "No se pudo restablecer la aceptación. Recarga la página antes de continuar.",
      "pt-BR": "Não foi possível limpar a referência do aceite. Recarregue a página antes de continuar."
    },
    "Checkout was stopped. Check your cart and details, then accept the policy again.": {
      es: "El proceso de pago se detuvo. Revisa el carrito y tus datos y acepta la política de nuevo.",
      "pt-BR": "A continuação foi interrompida. Confira o carrinho e seus dados e aceite a política novamente."
    },
    "Your cart changed. Please accept the policy again.": {
      es: "Tu carrito cambió. Acepta la política de nuevo.",
      "pt-BR": "Seu carrinho mudou. Aceite a política novamente."
    },
    "Your details changed. A new record is required.": {
      es: "Tus datos cambiaron. Es necesario un nuevo registro.",
      "pt-BR": "Seus dados mudaram. É necessário um novo registro."
    },
    "Acceptance selected. Enter your details to continue.": {
      es: "Aceptación seleccionada. Introduce tus datos para continuar.",
      "pt-BR": "Aceite selecionado. Preencha seus dados para continuar."
    },
    "Acceptance unchecked. A new acceptance is required.": {
      es: "Aceptación desmarcada. Es necesaria una nueva aceptación.",
      "pt-BR": "Aceite desmarcado. É necessário aceitar novamente."
    },
    "Please confirm your acceptance again.": {
      es: "Confirma tu aceptación de nuevo.",
      "pt-BR": "Confirme seu aceite novamente."
    }
  };
  const CHECKBOX = 'input[data-tncbox="gmtncBox"]';
  let busy = false;
  let revision = 0;
  let writes = Promise.resolve();
  let resetFailed = false;

  function drawer() {
    const rootPath = new URL(ROOT, location.origin).pathname;
    if (location.pathname.replace(/\/$/, "") === `${rootPath}cart`) {
      return document.getElementById("main-cart-footer");
    }
    return document.querySelector("cart-drawer");
  }

  function status(message) {
    const container = drawer();
    if (!container) return;
    const translated = MESSAGES[message]?.[LANGUAGE] || message;
    const element = container.querySelector(
      "#AlcoholConsentStatus, #AlcoholConsentPageStatus"
    );
    if (element) element.textContent = translated;

    // Also show feedback beside the visible checkout control. The existing
    // field status can be clipped by the drawer's scrollable layout.
    const button = container.querySelector(
      "#CartDrawer-Checkout, #checkout"
    );
    if (!button?.parentElement) return;
    let feedback = container.querySelector('[data-alcohol-consent-feedback]');
    if (!feedback || feedback.parentElement !== button.parentElement) {
      feedback?.remove();
      feedback = document.createElement("p");
      feedback.setAttribute("data-alcohol-consent-feedback", "");
      feedback.setAttribute("role", "status");
      feedback.setAttribute("aria-live", "polite");
      feedback.setAttribute("aria-atomic", "true");
      button.parentElement.insertBefore(feedback, button);
    }
    feedback.style.cssText = "display:block!important;visibility:visible!important;opacity:1!important;width:100%;flex:0 0 100%;margin:8px 0;white-space:normal;overflow-wrap:anywhere;font-size:14px;line-height:1.4;";
    feedback.textContent = translated;
    const validationMessages = [
      "Please accept the alcoholic beverages shipping policy.",
      "Please enter your full name.",
      "Please enter a valid email address.",
      "Checkout was stopped. Check your cart and details, then accept the policy again.",
      "Could not reset acceptance. Please reload before continuing."
    ];
    if (validationMessages.includes(message)) {
      feedback.style.color = "#b3261e";
      requestAnimationFrame(() => {
        if (feedback.isConnected) feedback.scrollIntoView({ block: "nearest" });
      });
    }
  }

  async function request(url, options = {}) {
    const response = await fetch(url, {
      ...options,
      cache: "no-store",
      signal: AbortSignal.timeout(15000)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    return data;
  }

  const TURNSTILE_SITE_KEY = "0x4AAAAAAFQwBq_XAu3ukbmz";
  let turnstileLoader;

  function loadTurnstile() {
    if (window.turnstile?.render) return Promise.resolve();
    if (turnstileLoader) return turnstileLoader;
    turnstileLoader = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      const timeout = setTimeout(() => reject(new Error("Turnstile loading timed out")), 20000);
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.onload = () => {
        clearTimeout(timeout);
        if (window.turnstile?.render) resolve();
        else reject(new Error("Turnstile unavailable"));
      };
      script.onerror = () => {
        clearTimeout(timeout);
        reject(new Error("Turnstile loading failed"));
      };
      document.head.appendChild(script);
    }).catch(error => {
      turnstileLoader = null;
      throw error;
    });
    return turnstileLoader;
  }

  async function getTurnstileToken(fields, startRevision, original) {
    await loadTurnstile();
    assertUnchanged(startRevision, original);
    if (!fields.isConnected) throw new Error("Acceptance fields replaced");
    return new Promise((resolve, reject) => {
      const host = document.createElement("div");
      host.style.margin = "12px 0";
      fields.appendChild(host);
      let widgetId;
      let settled = false;
      let timer;
      let watcher;
      function finish(error, token) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        clearInterval(watcher);
        // Defer widget removal until its callback has completed.
        setTimeout(() => {
          try {
            if (widgetId !== undefined) window.turnstile.remove(widgetId);
          } catch (_) {}
          host.remove();
        }, 0);
        if (error) reject(error);
        else resolve(token);
      }
      timer = setTimeout(() => finish(new Error("Security verification timed out")), 120000);
      watcher = setInterval(() => {
        try {
          assertUnchanged(startRevision, original);
          if (!host.isConnected) throw new Error("Security widget removed");
        } catch (error) { finish(error); }
      }, 200);
      try {
        widgetId = window.turnstile.render(host, {
          sitekey: TURNSTILE_SITE_KEY,
          action: "alcohol_consent",
          size: "flexible",
          language: LANGUAGE === "pt-BR" ? "pt-br" : LANGUAGE,
          callback: token => finish(null, token),
          "error-callback": () => finish(new Error("Security verification failed")),
          "expired-callback": () => finish(new Error("Security verification expired")),
          "timeout-callback": () => finish(new Error("Security challenge timed out"))
        });
      } catch (error) { finish(error); }
    });
  }

  function readCart() { return request(`${ROOT}cart.js`); }

  function fingerprint(cart) {
    return JSON.stringify({
      token: cart.token,
      items: cart.items.map(item => ({
        key: item.key,
        quantity: item.quantity,
        properties: item.properties,
        selling_plan: item.selling_plan_allocation,
        price: item.final_line_price
      }))
    });
  }

  function enqueue(operation) {
    const result = writes.then(operation);
    writes = result.catch(() => {});
    return result;
  }

  async function updateAttributes(attributes) {
    const cart = await request(`${ROOT}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes })
    });
    for (const [key, value] of Object.entries(attributes)) {
      if ((cart.attributes?.[key] || "") !== value) {
        throw new Error("Cart attribute verification failed");
      }
    }
    return cart;
  }

  function clearReference() {
    return enqueue(async () => {
      try {
        const cart = await updateAttributes({
          alcohol_consent_id: "",
          alcohol_terms_version: "",
          alcohol_terms_language: "",
          alcohol_terms_hash: ""
        });
        resetFailed = false;
        return cart;
      } catch (error) {
        resetFailed = true;
        throw error;
      }
    });
  }

  function invalidate(message, uncheck = false) {
    revision += 1;
    if (uncheck) {
      const checkbox = drawer()?.querySelector(CHECKBOX);
      if (checkbox) checkbox.checked = false;
    }
    status(message);
    clearReference().catch(error => {
      console.error("[Alcohol consent reset]", error);
      status("Could not reset acceptance. Please reload before continuing.");
    });
  }

  function values() {
    const container = drawer();
    const nameInput = container?.querySelector(
      "#AlcoholConsentName, #AlcoholConsentPageName"
    );
    const emailInput = container?.querySelector(
      "#AlcoholConsentEmail, #AlcoholConsentPageEmail"
    );
    return {
      fields: container?.querySelector(
        "#AlcoholConsentFields, #AlcoholConsentPageFields"
      ),
      checkbox: container?.querySelector(CHECKBOX),
      nameInput,
      emailInput,
      name: nameInput?.value.trim() || "",
      email: emailInput?.value.trim().toLowerCase() || ""
    };
  }

  function assertUnchanged(startRevision, original) {
    const current = values();
    if (
      revision !== startRevision ||
      !current.fields || !current.checkbox?.checked ||
      !window.AlcoholConsentPolicyUI?.ensure(drawer(), LANGUAGE) ||
      current.name !== original.name || current.email !== original.email
    ) {
      throw new Error("Acceptance or cart changed during submission");
    }
  }

  async function checkout(event) {
    const click = event.type === "click" &&
      event.target instanceof Element &&
      event.target.closest("#CartDrawer-Checkout, #main-cart-footer #checkout");
    const submit = event.type === "submit" &&
      event.target instanceof HTMLFormElement &&
      ["CartDrawer-Form", "cart"].includes(event.target.id);
    if (!click && !submit) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;

    busy = true;
    const startRevision = revision;
    let alcoholFlow = false;
    try {
      await writes;
      if (resetFailed) throw new Error("Previous reset failed");
      const cartBefore = await readCart();
      if (revision !== startRevision) throw new Error("Cart changed while checking");
      // Known localized values of the merchant's alcohol-only product type.
      const needsAcceptance = cartBefore.items.some(item =>
        ["Drink", "Bebida", "Beber"].includes(item.product_type)
      );

      if (!needsAcceptance) {
        await clearReference();
        const latest = await readCart();
        if (revision !== startRevision || fingerprint(latest) !== fingerprint(cartBefore)) {
          throw new Error("Cart changed before checkout");
        }
        window.location.assign(`${ROOT}checkout`);
        return;
      }

      alcoholFlow = true;
      const original = values();
      if (!original.fields) throw new Error("Alcohol acceptance fields are missing");
      if (!window.AlcoholConsentPolicyUI?.ensure(drawer(), LANGUAGE)) {
        throw new Error("Translated policy label or link is unavailable");
      }
      if (!original.checkbox?.checked) {
        status("Please accept the alcoholic beverages shipping policy.");
        original.checkbox?.focus();
        return;
      }
      if (!original.name || original.name.length > 200) {
        status("Please enter your full name.");
        original.nameInput?.focus();
        return;
      }
      if (!original.email || original.email.length > 254 || !original.emailInput?.checkValidity()) {
        status("Please enter a valid email address.");
        original.emailInput?.focus();
        return;
      }

      await clearReference();
      assertUnchanged(startRevision, original);
      status("Please complete the security verification if prompted.");
      const turnstileToken = await getTurnstileToken(original.fields, startRevision, original);
      assertUnchanged(startRevision, original);
      status("Recording your acceptance. Please wait.");
      const consent = await request(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: original.name,
          email: original.email,
          consent: true,
          turnstile_token: turnstileToken,
          terms_language: LANGUAGE,
          terms_version: TERMS_VERSION,
          terms_hash: POLICY_HASHES[LANGUAGE],
          page_url: location.origin + location.pathname
        })
      });
      if (consent.success !== true || typeof consent.id !== "string" || !consent.id ||
          consent.terms_version !== TERMS_VERSION || consent.terms_language !== LANGUAGE ||
          consent.terms_hash !== POLICY_HASHES[LANGUAGE]) {
        throw new Error("Invalid API response");
      }
      assertUnchanged(startRevision, original);
      const cartAfter = await readCart();
      assertUnchanged(startRevision, original);
      if (fingerprint(cartAfter) !== fingerprint(cartBefore)) {
        throw new Error("Cart contents changed");
      }

      await enqueue(async () => {
        assertUnchanged(startRevision, original);
        const updated = await updateAttributes({
          alcohol_consent_id: consent.id,
          alcohol_terms_version: TERMS_VERSION,
          alcohol_terms_language: LANGUAGE,
          alcohol_terms_hash: POLICY_HASHES[LANGUAGE]
        });
        assertUnchanged(startRevision, original);
        if (fingerprint(updated) !== fingerprint(cartBefore)) {
          throw new Error("Cart changed while saving reference");
        }
      });
      await writes;
      const finalCart = await readCart();
      assertUnchanged(startRevision, original);
      if (fingerprint(finalCart) !== fingerprint(cartBefore) ||
          finalCart.attributes?.alcohol_consent_id !== consent.id) {
        throw new Error("Final cart verification failed");
      }
      status("Acceptance recorded. Continuing to checkout.");
      window.location.assign(`${ROOT}checkout`);
    } catch (error) {
      console.error("[Alcohol consent]", error);
      try {
        await clearReference();
        status("Checkout was stopped. Check your cart and details, then accept the policy again.");
      } catch (resetError) {
        console.error("[Alcohol consent cleanup]", resetError);
        status("Could not reset acceptance. Please reload before continuing.");
      }
      if (alcoholFlow) {
        const checkbox = drawer()?.querySelector(CHECKBOX);
        if (checkbox) checkbox.checked = false;
      }
    } finally {
      busy = false;
    }
  }

  document.addEventListener("click", event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest("cart-drawer, cart-items") &&
        target.closest('button[name="plus"], button[name="minus"], cart-remove-button')) {
      invalidate("Your cart changed. Please accept the policy again.", true);
    }
  }, true);

  document.addEventListener("input", event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.matches(
      "#AlcoholConsentName, #AlcoholConsentEmail, #AlcoholConsentPageName, #AlcoholConsentPageEmail"
    )) {
      invalidate("Your details changed. A new record is required.");
    } else if (target.closest("cart-drawer, cart-items") &&
               target.matches('input[name="updates[]"]')) {
      invalidate("Your cart changed. Please accept the policy again.", true);
    }
  }, true);

  document.addEventListener("change", event => {
    const target = event.target;
    if (target instanceof HTMLInputElement &&
        target.closest("cart-drawer, #main-cart-footer, form#cart") &&
        target.matches(CHECKBOX)) {
      invalidate(target.checked
        ? "Acceptance selected. Enter your details to continue."
        : "Acceptance unchecked. A new acceptance is required.");
    }
  }, true);

  document.addEventListener("click", checkout, true);
  document.addEventListener("submit", checkout, true);

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      invalidate("Your cart changed. Please accept the policy again.", true);
    });
  } else {
    resetFailed = true;
    console.error("[Alcohol consent] Cart subscription unavailable.");
  }

  window.addEventListener("pageshow", event => {
    if (event.persisted) {
      invalidate("Please confirm your acceptance again.", true);
    }
  });
})();







